import React from "react";
import { Dropdown } from "primereact/dropdown";
import { Icon } from "@vds/icons";
import "./CustomDropdownWithHeaders.css";

const CustomDropdownWithHeaders = ({ setSelectedAction, selectedAction }) => {
  const dropdownOptions = [
    {
      label: "Hardware recommendation",
      items: [
        { label: "Set to Priority 1", value: "priority-1" },
        { label: "Set to Priority 2", value: "priority-2" },
        { label: "Set to Priority 3", value: "priority-3" },
      ],
    },
    {
      label: " ",
      items: [{ label: "Change Shipping information", value: "change-shipping" }],
    },
    {
      label: "",
      items: [{ label: "Delete Vehicles", value: "bulk-delete", isDelete: true }],
    },
  ];

  const customItemTemplate = (option) => {
    if (option.items) {
      // Render group header
      return (
        <div
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            color: "#000",
            cursor: "default",
          }}
        >
          {option.label}
        </div>
      );
    }

    // Render regular option
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          fontSize: "14px",
        }}
      >
        {option.isDelete && <Icon name="trash" size="small" color="#cc0000" />}
        <span style={{ color: option.isDelete ? "#cc0000" : "#000" }}>{option.label}</span>
      </div>
    );
  };

  const flattenOptions = (groups) => {
    const flattened = [];
    groups.forEach((group) => {
      if (group.label) {
        flattened.push({ label: group.label, items: group.items });
      }
      group.items.forEach((item) => {
        flattened.push(item);
      });
    });
    return flattened;
  };

  const flattenedOptions = flattenOptions(dropdownOptions);

  return (
    <div>
      <Dropdown
        value={selectedAction}
        options={flattenedOptions}
        onChange={(e) => setSelectedAction(e.value)}
        optionLabel="label"
        optionValue="value"
        itemTemplate={customItemTemplate}
        placeholder="Select action"
        style={{ width: "300px", marginLeft: "26px", fontFamily: "Verizon-NHG-eDS" }}
      />
    </div>
  );
};

export default CustomDropdownWithHeaders;
